import { action } from "satcheljs";

import type { OwaNovaActionUnion } from "../types";

export const onShowToast = action("onShowToast", event => ({
    event,
    owaType: "showToast",
})) as OwaNovaActionUnion<"showToast">;
